/**
 * DOM-free numeric helpers for the renderer: easing curves, a cheap smooth
 * 1D value noise (camera shake, beam wobble) and a stable hash random for
 * jitter that must not change within a frame (arc polylines). Kept apart
 * from gfx.ts so the camera and the dev scene can be unit-tested under the
 * node lib.
 */

export function easeOutCubic(t: number): number { const u = 1 - t; return 1 - u * u * u; }
export function easeOutBack(t: number): number { const c = 1.70158; const u = t - 1; return 1 + (c + 1) * u * u * u + c * u * u; }
export function easeInQuad(t: number): number { return t * t; }
export function clamp01(t: number): number { return t < 0 ? 0 : t > 1 ? 1 : t; }

function hash1(i: number): number {
  let x = (i | 0) * 374761393;
  x = (x ^ (x >>> 13)) * 1274126177;
  x = x ^ (x >>> 16);
  return (x >>> 0) / 4294967296;
}

/** Smooth value noise in [-1, 1]; `t` in arbitrary units (use seconds x frequency). */
export function noise1D(t: number): number {
  const i = Math.floor(t);
  const f = t - i;
  const u = f * f * (3 - 2 * f);
  const a = hash1(i) * 2 - 1;
  const b = hash1(i + 1) * 2 - 1;
  return a + (b - a) * u;
}

/** Deterministic pseudo-random in [0, 1) for jitter that must be stable within a frame. */
export function hashRand(seed: number, i: number): number {
  return hash1(seed * 7919 + i * 104729);
}
